import { Trans } from '@lingui/react/macro';

import { useCanaryFinalRecommendations } from '@/api/aiVisibility';
import { Empty } from '@/components/Empty';
import WidgetError from '@/components/errors/WidgetError';
import { Skeleton } from '@/components/Skeleton';
import { Text, Title } from '@/components/typography';
import useInstanceNavigate from '@/hooks/useInstanceNavigate';
import { ROUTES } from '@/router';

import RecommendationCard from './RecommendationCard';

const AIVisibilityOverviewTopGaps = () => {
  const { recommendations, isLoading, error } = useCanaryFinalRecommendations();
  const navigate = useInstanceNavigate();
  const topRecommendations = [...(recommendations ?? [])]
    .sort(
      (first, second) =>
        (first.priority ?? Number.MAX_SAFE_INTEGER) - (second.priority ?? Number.MAX_SAFE_INTEGER),
    )
    .slice(0, 3);

  return (
    <section className="min-h-48 rounded-2xl bg-gray-100 px-5 py-4">
      <div className="flex flex-wrap items-center justify-between gap-3 px-2.5">
        <Title level={2} variant="label">
          <Trans>TOP GAPS TO CLOSE</Trans>
        </Title>
        {!!recommendations?.length && (
          <button
            type="button"
            className="cursor-pointer text-aqua-600 underline"
            onClick={() => navigate(ROUTES.aiVisibilityRecommendations.path)}
          >
            <Text variant="footnote" className="text-inherit">
              <Trans>All {recommendations.length} recommendations</Trans> →
            </Text>
          </button>
        )}
      </div>
      {isLoading && (
        <div className="mt-4 grid gap-5 xl:grid-cols-3" aria-busy="true">
          {Array.from({ length: 3 }, (_, index) => (
            <Skeleton key={index} className="h-36 rounded-2xl" />
          ))}
        </div>
      )}
      {!isLoading && !!error && (
        <WidgetError message={<Trans>Unable to load recommendations.</Trans>} />
      )}
      {!isLoading && !error && !topRecommendations.length && (
        <Empty>
          <Trans>No recommendations available.</Trans>
        </Empty>
      )}
      {!isLoading && !error && !!topRecommendations.length && (
        <div className="mt-4 grid gap-5 xl:grid-cols-3">
          {topRecommendations.map((recommendation) => (
            <RecommendationCard
              key={recommendation.id}
              recommendation={recommendation}
              truncateDiagnosis
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default AIVisibilityOverviewTopGaps;
